/*
 * @Author: cryi.liu
 * @Date: 2020-05-08 16:57:33
 * @LastEditTime: 2020-07-16 18:01:57
 * @Description: 创建试卷数据仓库
 */
export default {
  namespaced: true,

  state: {
    pageType: '', // create为创建试卷，edit为修改试卷
    // 产品组组题modal
    addQuestionByProductGroupModal: {
      show: false,
      type: '', // add为创建大类，update为添加题目
    },
    // 产品型号组题modal
    addQuestionByProductCodeModal: {
      show: false,
      type: '', // add为创建大类，update为添加题目
    },
    // 试卷名称
    paperName: '',
    // 试卷id
    paperId: '',
    // 所有大题
    bigQuestions: [],
    // 考试时间
    examTime: 0,
    // 考试通过分数
    examPassScore: 0,
    // 组题方式
    comQuestionType: '',
    // 添加大类组题规则
    addBigQuestionRule: {
      paperId: '',
      partId: '',
      questionType: '',
      productLibraryTypeList: [],
      groupCodeMap: {},
      levels: [],
      libraryTypes: [],
      productNames: [],
      years: [],
      productGroupCodes: [],
      productCodes: [],
    },
    addExamObjectType: 'Scope',
    canAddExamObject: true,
    canAddExamObjectForUploadExcel: true,
    thirdPartyUserRule: {
      branchCode: 'all',
      subBranchCode: 'all',
      channelCode: 'all',
      comChannelCode: 'all',
      userTypeId: 'all',
      userTypeDetailId: 'all',
      starLevel: 'all',
      mainGroup: 'all',
    },
    noThirdPartyUserRule: {
      branchCode: 'all',
      subBranchCode: 'all',
      channelCode: 'all',
      comChannelCode: 'all',
      groupId: 'all',
    },
    // 创建试卷第三步，题目统计信息
    questionComplete: [],
    // 考试对象列表
    examObjectList: [],
    // 考试对象总数
    examObjectTotal: 0,
  },

  getters: {
    // 获取页面类型
    pageType({ pageType }) {
      return pageType;
    },
    // 产品组组题modal显示状态
    addQuestionByProductGroupModalShow({ addQuestionByProductGroupModal }) {
      return addQuestionByProductGroupModal.show;
    },
    // 产品组组题modal类型
    addQuestionByProductGroupModalType({ addQuestionByProductGroupModal }) {
      return addQuestionByProductGroupModal.type;
    },
    // 产品型号组题modal显示状态
    addQuestionByProductCodeModalShow({ addQuestionByProductCodeModal }) {
      return addQuestionByProductCodeModal.show;
    },
    // 产品型号组题modal类型
    addQuestionByProductCodeModalType({ addQuestionByProductCodeModal }) {
      return addQuestionByProductCodeModal.type;
    },
    // 获取试卷名称
    paperName({ paperName }) {
      return paperName;
    },
    // 获取试卷id
    paperId({ paperId }) {
      return paperId;
    },
    // 获取考试时间
    examTime({ examTime }) {
      return examTime;
    },
    // 获取考试通过分数
    examPassScore({ examPassScore }) {
      return examPassScore;
    },
    // 获取所有大题
    bigQuestions({ bigQuestions }) {
      return bigQuestions;
    },
    // 获取组题方式
    comQuestionType({ comQuestionType }) {
      return comQuestionType;
    },
    // 获取添加大类组题规则
    addBigQuestionRule({ addBigQuestionRule }) {
      return addBigQuestionRule;
    },
    //  获取添加考试对象方式
    addExamObjectType({ addExamObjectType }) {
      return addExamObjectType;
    },
    // 获取是否能添加考试对象
    canAddExamObject({ canAddExamObject }) {
      return canAddExamObject;
    },
    // 获取是否能通过上传 Excel 添加考试对象
    canAddExamObjectForUploadExcel({ canAddExamObjectForUploadExcel }) {
      return canAddExamObjectForUploadExcel;
    },
    // 获取添加第三方员工考试对象规则
    thirdPartyUserRule({ thirdPartyUserRule }) {
      return thirdPartyUserRule;
    },
    // 获取添加非第三方员工考试对象规则
    noThirdPartyUserRule({ noThirdPartyUserRule }) {
      return noThirdPartyUserRule;
    },
    // 获取创建试卷第三步，题目统计信息
    questionComplete({ questionComplete }) {
      return questionComplete;
    },
    // 获取考试对象列表
    examObjectList({ examObjectList }) {
      return examObjectList;
    },
    // 获取考试对象总数
    examObjectTotal({ examObjectTotal }) {
      return examObjectTotal;
    },
  },

  mutations: {
    // 设置页面类型
    setPageType(state, { type }) {
      state.pageType = type;
    },
    // 设置产品组组题modal显示状态
    setAddQuestionByProductGroupModalShow(state, { show }) {
      state.addQuestionByProductGroupModal.show = show;
    },
    // 设置产品组组题modal类型
    setAddQuestionByProductGroupModalType(state, { type }) {
      state.addQuestionByProductGroupModal.type = type;
    },
    // 设置产品型号组题modal显示状态
    setAddQuestionByProductCodeModalShow(state, { show }) {
      state.addQuestionByProductCodeModal.show = show;
    },
    // 设置产品型号组题modal类型
    setAddQuestionByProductCodeModalType(state, { type }) {
      state.addQuestionByProductCodeModal.type = type;
    },
    // 设置试卷名称
    setPaperName(state, { paperName }) {
      state.paperName = paperName;
    },
    // 设置试卷id
    setPaperId(state, { paperId }) {
      state.paperId = paperId;
      state.addBigQuestionRule.paperId = paperId;
    },
    // 设置考试时间
    setExamTime(state, { examTime }) {
      state.examTime = examTime;
    },
    // 设置考试通过分数
    setExamPassScore(state, { examPassScore }) {
      state.examPassScore = examPassScore;
    },
    // 设置所有大题
    setBigQuestions(state, { bigQuestions }) {
      state.bigQuestions = bigQuestions;
    },
    // 设置组题方式
    setComQuestionType(state, { comQuestionType }) {
      state.comQuestionType = comQuestionType;
    },
    // 设置添加大类组题规则
    setAddBigQuestionRule(state, { addBigQuestionRule }) {
      state.addBigQuestionRule = addBigQuestionRule;
    },
    // 重置添加大类组题规则
    resetAddBigQuestionRule(state) {
      // 除paperId，其余重置
      state.addBigQuestionRule.partId = '';
      state.addBigQuestionRule.questionType = '';
      state.addBigQuestionRule.groupCodeMap = {};
      state.addBigQuestionRule.levels = [];
      state.addBigQuestionRule.libraryTypes = [];
      state.addBigQuestionRule.productNames = [];
      state.addBigQuestionRule.years = [];
      state.addBigQuestionRule.productGroupCodes = [];
      state.addBigQuestionRule.productCodes = [];
    },
    // 设置添加大类组题规则中的大题类型
    setAddBigQuestionRuleOfQuestionType(state, { questionType }) {
      state.addBigQuestionRule.questionType = questionType;
    },
    // 设置添加大类组题规则中的大题类型
    setAddBigQuestionRuleOfPartId(state, { partId }) {
      state.addBigQuestionRule.partId = partId;
    },
    // 设置添加大类组题规则中的年份筛选条件
    setAddBigQuestionRuleOfYears(state, { years }) {
      state.addBigQuestionRule.years = years;
    },
    // 设置添加大类组题规则中的难易度筛选条件
    setAddBigQuestionRuleOfLevels(state, { levels }) {
      state.addBigQuestionRule.levels = levels;
    },
    // 设置添加大类组题规则中的所属题库筛选条件
    setAddBigQuestionRuleOfLibraryTypes(state, { libraryTypes }) {
      state.addBigQuestionRule.libraryTypes = libraryTypes;
    },
    // 设置添加大类组题规则中的产品型号筛选条件
    setAddBigQuestionRuleOfProductNames(state, { productNames }) {
      state.addBigQuestionRule.productNames = productNames;
    },
    // 设置添加大类组题规则中的产品组筛选条件
    setAddBigQuestionRuleOfProductGroupCodes(state, { productGroupCodes }) {
      state.addBigQuestionRule.productGroupCodes = productGroupCodes;
    },
    // 设置添加大类组题规则中的产品型号筛选条件条件
    setAddBigQuestionRuleOfProductCodes(state, { productCodes }) {
      state.addBigQuestionRule.productCodes = productCodes;
    },
    // 设置添加大类组题规则中产品型号选题数
    setAddBigQuestionRuleOfProductLibraryTypeList(state, { list }) {
      state.addBigQuestionRule.productLibraryTypeList = list;
    },
    // 设置添加大类组题规则中产品组选题数
    setAddBigQuestionRuleOfGroupCodeMap(state, { groupCodeMap }) {
      state.addBigQuestionRule.groupCodeMap = groupCodeMap;
    },
    // 设置添加考试对象方式
    setAddExamObjectType(state, { addExamObjectType }) {
      state.addExamObjectType = addExamObjectType;
    },
    // 设置是否能添加考试对象
    setCanAddExamObject(state, { canAddExamObject }) {
      state.canAddExamObject = canAddExamObject;
    },
    // 获取是否能通过上传 Excel 添加考试对象
    setCanAddExamObjectForUploadExcel(state, { canAddExamObjectForUploadExcel }) {
      state.canAddExamObjectForUploadExcel = canAddExamObjectForUploadExcel;
    },
    // 获取添加第三方员工考试对象规则
    setThirdPartyUserRule(state, { thirdPartyUserRule }) {
      state.thirdPartyUserRule = thirdPartyUserRule;
    },
    // 获取添加非第三方员工考试对象规则
    setNoThirdPartyUserRule(state, { noThirdPartyUserRule }) {
      state.noThirdPartyUserRule = noThirdPartyUserRule;
    },
    // 设置创建试卷第三步，题目统计信息
    setQuestionComplete(state, { questionComplete }) {
      state.questionComplete = questionComplete;
    },
    // 设置考试对象列表
    setExamObjectList(state, { examObjectList }) {
      state.examObjectList = examObjectList;
    },
    // 设置考试对象总数
    setExamObjectTotal(state, { examObjectTotal }) {
      state.examObjectTotal = examObjectTotal;
    },
  },

  actions: {
    invokeSetPageType({ commit }, payload) {
      commit('setPageType', payload);
    },
    invokeSetAddQuestionByProductGroupModalShow({ commit }, payload) {
      commit('setAddQuestionByProductGroupModalShow', payload);
    },
    invokeSetAddQuestionByProductGroupModalType({ commit }, payload) {
      commit('setAddQuestionByProductGroupModalType', payload);
    },
    invokeSetAddQuestionByProductCodeModalShow({ commit }, payload) {
      commit('setAddQuestionByProductCodeModalShow', payload);
    },
    invokeSetAddQuestionByProductCodeModalType({ commit }, payload) {
      commit('setAddQuestionByProductCodeModalType', payload);
    },
    invokeSetPaperName({ commit }, payload) {
      commit('setPaperName', payload);
    },
    invokeSetPaperId({ commit }, payload) {
      commit('setPaperId', payload);
    },
    invokeSetExamTime({ commit }, payload) {
      commit('setExamTime', payload);
    },
    invokeSetExamPassScore({ commit }, payload) {
      commit('setExamPassScore', payload);
    },
    invokeSetBigQuestions({ commit }, payload) {
      commit('setBigQuestions', payload);
    },
    invokeSetComQuestionType({ commit }, payload) {
      commit('setComQuestionType', payload);
    },
    invokeSetAddBigQuestionRule({ commit }, payload) {
      commit('setAddBigQuestionRule', payload);
    },
    invokeResetAddBigQuestionRule({ commit }) {
      commit('resetAddBigQuestionRule');
    },
    invokeSetAddBigQuestionRuleOfPartId({ commit }, payload) {
      commit('setAddBigQuestionRuleOfPartId', payload);
    },
    invokeSetAddBigQuestionRuleOfQuestionType({ commit }, payload) {
      commit('setAddBigQuestionRuleOfQuestionType', payload);
    },
    invokeSetAddBigQuestionRuleOfYears({ commit }, payload) {
      commit('setAddBigQuestionRuleOfYears', payload);
    },
    invokeSetAddBigQuestionRuleOfLevels({ commit }, payload) {
      commit('setAddBigQuestionRuleOfLevels', payload);
    },
    invokeSetAddBigQuestionRuleOfLibraryTypes({ commit }, payload) {
      commit('setAddBigQuestionRuleOfLibraryTypes', payload);
    },
    invokeSetAddBigQuestionRuleOfProductNames({ commit }, payload) {
      commit('setAddBigQuestionRuleOfProductNames', payload);
    },
    invokeSetAddBigQuestionRuleOfProductGroupCodes({ commit }, payload) {
      commit('setAddBigQuestionRuleOfProductGroupCodes', payload);
    },
    invokeSetAddBigQuestionRuleOfProductCodes({ commit }, payload) {
      commit('setAddBigQuestionRuleOfProductCodes', payload);
    },
    invokeSetAddBigQuestionRuleOfProductLibraryTypeList({ commit }, payload) {
      commit('setAddBigQuestionRuleOfProductLibraryTypeList', payload);
    },
    invokeSetAddBigQuestionRuleOfGroupCodeMap({ commit }, payload) {
      commit('setAddBigQuestionRuleOfGroupCodeMap', payload);
    },
    invokeSetAddExamObjectType({ commit }, payload) {
      commit('setAddExamObjectType', payload);
    },
    invokeSetCanAddExamObject({ commit }, payload) {
      commit('setCanAddExamObject', payload);
    },
    invokeSetCanAddExamObjectForUploadExcel({ commit }, payload) {
      commit('setCanAddExamObjectForUploadExcel', payload);
    },
    invokeSetThirdPartyUserRule({ commit }, payload) {
      commit('setThirdPartyUserRule', payload);
    },
    invokeSetNoThirdPartyUserRule({ commit }, payload) {
      commit('setNoThirdPartyUserRule', payload);
    },
    invokeSetQuestionComplete({ commit }, payload) {
      commit('setQuestionComplete', payload);
    },
    invokeSetExamObjectList({ commit }, payload) {
      commit('setExamObjectList', payload);
    },
    invokeSetExamObjectTotal({ commit }, payload) {
      commit('setExamObjectTotal', payload);
    },
  },
};
